module.exports = __webpack_public_path__ + "static/Gilroy-Medium-d00e876b339a56ae4718ed4e2208c4a3.woff2";